export default __webpack_public_path__ + "static/media/combined-shape.d0edfd5b.svg";